import { FormDateInline } from '@core/components/form';
import { FormControl } from '@core/utils/form';
import { TimeInput, toMoment } from '@core/utils/time';
import { GCDropdown } from '@modules/common/GCDropdown';
import { Button, ConfigProvider, DatePicker } from 'antd';
import React, { memo, ReactNode, useEffect } from 'react';
import type { Moment } from 'moment';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import { useObservable } from '@core/utils/hooks/rxjs';

const MomentDatePicker = DatePicker.generatePicker<Moment>(momentGenerateConfig);
export interface FormDropdownDateProps {
  control: FormControl<number>;
  minDate?: TimeInput;
  maxDate?: TimeInput;
  children?: ReactNode;
  onChange?(date: number | undefined): void;
  clearable?: boolean;
}

export const FormDropdownDate = memo((props: FormDropdownDateProps) => {
  const { children, control, onChange, clearable = false, ...rest } = props;
  const controlValue = useObservable(control.value$);
  const [isTime, setIsTime] = React.useState(false);
  const mNow = toMoment().unix();
  const status = controlValue && mNow > toMoment(controlValue).unix() ? 'error' : undefined;

  useEffect(() => {
    if (controlValue && toMoment(controlValue).unix() != toMoment(controlValue).endOf('day').unix()) {
      setIsTime(true);
    } else if (!controlValue) {
      setIsTime(false);
    }
  }, [controlValue]);

  const handleValueChange = React.useCallback(
    (value: Moment | null, triggerChange: boolean = true) => {
      if (!value) {
        control.setValue(undefined);
        if (triggerChange) {
          onChange && onChange(undefined);
        }
      } else {
        const timestamp = isTime ? value.unix() : value.endOf('day').unix();
        control.setValue(timestamp);
        if (triggerChange) {
          onChange && onChange(timestamp);
        }
      }
    },
    [control, onChange, isTime],
  );
  return (
    <ConfigProvider
      theme={{
        components: {
          DatePicker: {},
        },
      }}
    >
      <MomentDatePicker
        status={status}
        placeholder=""
        className="dd-datepicker"
        format={isTime ? 'M/D hh:mma' : 'M/D'}
        variant="borderless"
        allowClear={clearable}
        showTime={
          isTime
            ? {
                format: 'hh:mma',
                use12Hours: true,
                minuteStep: 15,
                hideDisabledOptions: true,
              }
            : false
        }
        value={controlValue ? toMoment(controlValue) : null}
        onOk={value => {
          handleValueChange(value, true);
        }}
        renderExtraFooter={() => (
          <div className="ml-2 mr-2">
            <Button
              variant="text"
              onClick={() => {
                setIsTime(!isTime);
                control.setValue(toMoment(controlValue).endOf('day').unix());
                onChange && onChange(toMoment(controlValue).endOf('day').unix());
              }}
            >
              Time
            </Button>
          </div>
        )}
        onChange={value => {
          console.log('value', value);
          // For time picker, we only want to update on OK click, not on every change
          handleValueChange(value, true);
        }}
      />
    </ConfigProvider>
  );
  //   return (
  //     <GCDropdown target={children}>
  //       {setOpen => (
  //         <div className="p-4">
  //           <FormDateInline
  //             onChange={date => {
  //               setOpen(false);
  //               onChange && onChange(toMoment(date).endOf('day').unix());
  //             }}
  //             control={control}
  //             {...rest}
  //           />
  //           {clearable && (
  //             <Button
  //               color="dark"
  //               outline
  //               onClick={() => {
  //                 setOpen(false);
  //                 control.setValue(null);
  //                 onChange && onChange(undefined);
  //               }}
  //             >
  //               Clear
  //             </Button>
  //           )}
  //         </div>
  //       )}
  //     </GCDropdown>
  //   );
});
